<template>
  <div>
    <v-toolbar
      color="white"
      dense
      flat
    >
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        flat 
        @click="loginClick"
        v-if="!token"
      >
        Login
      </v-btn>
      <v-btn
        color="primary"
        flat 
        @click="goToDashboard"
        v-else
      >
        dashboard
      </v-btn>
    </v-toolbar>
    <carousel></carousel>
    <sample-modules
      class="mt-5"
    ></sample-modules>
    <parallax
      class="mt-5"
    ></parallax>
    <div
      :style="{ backgroundImage: 'url(' + bg + ')', backgroundPosition: 'center' }"
    >
      <registration></registration>
    </div>
    <v-divider></v-divider>
    <main-footer></main-footer>
  </div>
</template>

<script>
import Carousel from '@/components/home/carousel'
import SampleModules from '@/components/home/sampleModules'
import Parallax from '@/components/home/parallax'
import Registration from '@/components/home/registration'
import MainFooter from '@/components/mainFooter'
import {getAuthToken} from '@/utils/token'

export default {
  components: {
    Carousel,
    SampleModules,
    Parallax,
    Registration,
    MainFooter
  },
  data () {
    return {
      bg: require('@/assets/bg/water_6.png'),
      token: getAuthToken()
    }
  },
  methods: {
    loginClick () {
      this.$router.push('/login')
    },
    goToDashboard () {
      this.$router.push('/dashboard')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/home/index.vue